import { StreamActions, FrameElement } from '@hotwired/turbo'

StreamActions.reload_frame = function () {
  const id = this.getAttribute('id') as string

  void (document.querySelector(`turbo-frame#${id}`) as FrameElement)?.reload()
}
